import { Popconfirm as PopconfimAntd } from 'antd';
import PopconfirmStyled from './styles/popconfirm.style';

const Popconfirm = PopconfirmStyled(PopconfimAntd);

export default Popconfirm;
